export enum LoginRoutes {
  login = 'login'
}
